import React from 'react';

import styles from './styles/database-common.module.css';

export default function DatabaseCommon({ stepLength, currentStep, setCurrentStepName }) {
    const { id, title, subTitle, component } = currentStep;

    return (
        <div className={styles.wrapper}>
            <div className={styles.containerInfo}>
                <div className={styles.boxSequence}>
                    <span>{id}</span>/{stepLength}</div>
                <div className={styles.boxTitle}>
                    <p className={styles.title}>{title}</p>
                    <p className={styles.subTitle}>{subTitle}</p>
                </div>
            </div>
            {component}
        </div>
    );
}
